import React from 'react';
import { ExternalLink } from 'lucide-react';

const BookAuthoritySection = () => {
  return (
    <section className="section-padding bg-[var(--bg-primary)]">
      <div className="container">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="heading-2 mb-4">
              The Book That Started the Protection Conversation
            </h2>
            <p className="body-large text-[var(--text-secondary)] max-w-3xl mx-auto">
              <em>Insurance Is Not Protection</em> explains why many families own policies — yet remain financially exposed without realizing it.
            </p>
          </div>
          
          {/* Book Image & CTA */}
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            {/* Book Image */}
            <div className="w-full md:w-1/2 flex justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_b2ceecb0-da08-477c-bdbc-45b3f8bca466/artifacts/9gsen32a_Ebook%20Gift%20Image.png"
                alt="Insurance Is Not Protection Book"
                className="w-full max-w-md h-auto rounded-lg shadow-lg"
                loading="lazy"
              />
            </div>
            
            {/* CTA Section */}
            <div className="w-full md:w-1/2 text-center md:text-left">
              <div className="space-y-4">
                <a
                  href="https://superprofile.bio/vp/69b3ec33afac6d001315a232"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-gold inline-flex items-center gap-2"
                >
                  View the Book
                  <ExternalLink size={16} />
                </a>
                
                <p className="body-regular text-[var(--text-secondary)]">
                  Available on Amazon & Kindle
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookAuthoritySection;
